import { render, staticRenderFns } from "./Greens.vue?vue&type=template&id=788ec5f9&"
import script from "./Greens.vue?vue&type=script&lang=js&"
export * from "./Greens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports